import {createContext as $5zex2$createContext, Component as $5zex2$Component} from "react";
import $5zex2$macrostrathyper from "@macrostrat/hyper";



// Default value for computePhotoPath
const $32842fb3e30f6a2a$var$computePhotoPath = (src)=>src;
const $32842fb3e30f6a2a$export$9f4be09e3914797a = (0, $5zex2$createContext)({
    photos: null,
    computePhotoPath: $32842fb3e30f6a2a$var$computePhotoPath
});
class $32842fb3e30f6a2a$export$77971d5b6cbacaf9 extends (0, $5zex2$Component) {
    static #_ = this.defaultProps = {
        computePhotoPath: $32842fb3e30f6a2a$var$computePhotoPath
    };
    render() {
        const { children: children, ...rest } = this.props;
        return (0, $5zex2$macrostrathyper)($32842fb3e30f6a2a$export$9f4be09e3914797a.Provider, {
            value: rest,
            children: children
        });
    }
}


//# sourceMappingURL=context.8ac8a66d.js.map
